import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'stores/Store';
import { identifyUser, initAnalytics, resetUser } from 'lib/analytics';

/**
 * Boots PostHog once and identifies the current user whenever authUser
 * transitions from anonymous -> authed (and resets on logout). Kept as a
 * component (not a context) because nothing downstream needs to read from
 * it; the analytics layer is module-scoped.
 */
const PostHogProvider = observer(({ children }) => {
    const { authUser } = useStore();

    useEffect(() => {
        initAnalytics();
    }, []);

    useEffect(() => {
        if (authUser?.Id) {
            identifyUser(authUser.Id, {
                email: authUser.Email || undefined,
                username: authUser.Username || undefined,
                is_vendor: !!authUser.Roles?.Vendor,
                is_admin: !!authUser.Roles?.Admin,
            });
        } else {
            resetUser();
        }
    }, [authUser?.Id, authUser?.Email, authUser?.Username]);

    return children;
});

export { PostHogProvider };
